import TabPanel from "../Reusable/Tab";
import EditCourierPickupRequest from "./EditCourierPickupRequest";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";

const SwitchTab = (props: any) => {
  const {
    isLoading,
    data,
    handleAttachConsignment,
    handleToggleMarkAsDone,
    defaultValue,
    setDefaultValue,
    gridData,
    id,
    handlecheckConsignments,
    handleAddVehicle,
    isVehicleLoading,
    handleStatusChange,
    handleAddDriver,
    isDriverLoading,
    handleUpdate,
    handlecheckConsignmentsPickup,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
  } = props;
  return (
    <>
      <>
        <TabPanel
          tabTitle={["Update", "Documents"]}
          tabPanels={[
            <>
              <EditCourierPickupRequest
                isLoading={isLoading}
                data={data}
                handleAttachConsignment={handleAttachConsignment}
                handleToggleMarkAsDone={handleToggleMarkAsDone}
                defaultValue={defaultValue}
                setDefaultValue={setDefaultValue}
                gridData={gridData}
                handlecheckConsignments={handlecheckConsignments}
                handlecheckConsignmentsPickup={handlecheckConsignmentsPickup}
                handleAddVehicle={handleAddVehicle}
                isVehicleLoading={isVehicleLoading}
                handleAddDriver={handleAddDriver}
                isDriverLoading={isDriverLoading}
                handleStatusChange={handleStatusChange}
                handleUpdate={handleUpdate}
                openAddDriverPopup={openAddDriverPopup}
                openAddVehiclePopup={openAddVehiclePopup}
                setOpenAddDriverPopup={setOpenAddDriverPopup}
                setOpenAddVehiclePopup={setOpenAddVehiclePopup}
              />
            </>,
            <>
              <FileUpload object_id={id} />
            </>,
          ]}
        />
      </>
    </>
  );
};

export default SwitchTab;
